import { Directive, effect, input, signal } from '@angular/core'

import { fonts, theme } from '@flowx/core-sdk'
import { InputSelectionStyles, applyInputCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-input',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxInputStyleDirective {
  componentStyle = input<{
    style: InputSelectionStyles
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyInputCustomStyles(this.componentStyle().style, theme(), fonts())
      this.styleClassName.set(className)
    })
  }
}
